import { css } from '@emotion/react';
import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { theme } from '@frontend/theme';
import { Accordion } from '@frontend/design-system';
import { useScheduleActionsContext } from '../../ScheduleActionsContext';
import { ScheduleActionsProvider } from '../../ScheduleActionsProvider';
import { ScheduleRequestContextProvider } from '../Context/ScheduleRequestContext';
import { useScheduleRequestContextValue } from '../hooks/use-schedule-request-context-value';
import { useScheduleRequestModalContextValue } from '../hooks/use-schedule-request-modal-context-value';
import { ScheduleRequestTray } from '../ScheduleRequestModal/ScheduleRequestWrappers/ScheduleRequestTray';
import { SchedulePulseRequestListItem } from './SchedulePulseRequestList/SchedulePulseRequestListItem';
import { ScheduleRequestFormManager } from './ScheduleRequestFormManager';

type ScheduleRequestListContentProps = {
  scheduleRequests: ScheduleRequest[];
};

const WrappedScheduleRequestList = ({ scheduleRequests }: ScheduleRequestListContentProps) => {
  const { selectedScheduleRequest, setSelectedScheduleRequest, scheduleRequestModalContextValue } =
    useScheduleRequestModalContextValue({ refetchScheduleRequestList: () => {} });
  const { scheduleRequestModalProps } = scheduleRequestModalContextValue;
  const scheduleActionsContextValue = useScheduleActionsContext();

  const { providerValue } = useScheduleRequestContextValue({ refetchScheduleRequestList: () => {} });

  return (
    <>
      <ScheduleRequestContextProvider value={providerValue}>
        <Accordion css={{ paddingTop: theme.spacing(0.5) }}>
          {scheduleRequests.map((listItem) => (
            <SchedulePulseRequestListItem
              key={listItem.id}
              listItem={listItem}
              setSelectedScheduleRequest={setSelectedScheduleRequest}
              scheduleRequestModalProps={scheduleRequestModalProps}
              css={styles.listItem}
            />
          ))}
        </Accordion>
      </ScheduleRequestContextProvider>
      {selectedScheduleRequest && (
        <ScheduleRequestFormManager
          wrapper={ScheduleRequestTray}
          scheduleRequestModalContextValue={scheduleRequestModalContextValue}
          selectedScheduleRequest={selectedScheduleRequest}
          scheduleActionsContextValue={scheduleActionsContextValue}
        />
      )}
    </>
  );
};

export const ScheduleRequestList = (props: ScheduleRequestListContentProps) => {
  return (
    <ScheduleActionsProvider>
      <WrappedScheduleRequestList {...props} />
    </ScheduleActionsProvider>
  );
};

const styles = {
  listItem: css`
    margin-bottom: 0;
    box-shadow: none;
    border-radius: 0;
  `,
};
